// extracted by mini-css-extract-plugin
module.exports = {"systemAlert":"system-alert_systemAlert__2DaDs","systemAlertCloseButton":"system-alert_systemAlertCloseButton__U_4Oq"};